/**
 * Story 059 — TanStack Query keys for the turbine-models feature.
 */
import type { ListAssetModelsExpandedParams } from "./types.js";

export const assetModelsKeys = {
  all: ["asset-models"] as const,
  lists: () => [...assetModelsKeys.all, "list"] as const,
  list: (params: ListAssetModelsExpandedParams) =>
    [...assetModelsKeys.lists(), params] as const,
  detail: (id: string) => [...assetModelsKeys.all, "detail", id] as const,
  /** ASM-SPEC-01 — the suggestion catalogue (global rows + this tenant's
   *  learned pairs). Invalidated on every successful create/update, because
   *  the BE learns a new pair on Save. */
  specificationParameters: () =>
    [...assetModelsKeys.all, "specification-parameters"] as const,
};
